import strings from "../../../utils/Strings";

export const validateEmail = (email: string): boolean => {
  return /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/.test(email);
};

export const validatePasswordsMatch = (
  password: string,
  confirmPassword: string,
) => {
  return password === confirmPassword;
};

export const validateZipCode = (value: string) => {
  const sanitizedValue = value.trim();
  const regex = /^[A-Z0-9]{1,16}$/;
  if (!regex.test(sanitizedValue)) {
    return "*Please enter a valid zip code format";
  }
  return "";
};

export const validateRequiredFields = (fields: string[], userData: any) => {
  const errors: any = {};
  fields.forEach((field) => {
    if (!userData[field]) {
      errors[field] = "*Please fill the mandatory field";
    }
  });
  return errors;
};

export const validatePassword = (password: string) => {
  const trimmedPassword = password.trim();

  if (!trimmedPassword) {
    return strings.validation.passwordError;
  }

  if (password.includes(" ")) {
    return strings.validation.passwordSpaceError;
  }

  // if (password.length < 8 || password.length > 16) {
  //   return strings.validation.passwordLengthError;
  // }

  return "";
};

export const validateOrganizationName = (value: string) => {
  const sanitizedValue = value.trim();
  const regex = /^[a-zA-Z0-9 .'-]{3,256}$/;
  if (!regex.test(sanitizedValue)) {
    return "*Please enter a valid organization name";
  }
  return "";
};

export const validateName = (value: string) => {
  const sanitizedValue = value.trim();
  const regex = /^[a-zA-Z ]{2,256}$/;
  if (!regex.test(sanitizedValue)) {
    return "* Enter the value in the appropriate format.";
  }
  return "";
};

export const validateLastName = (value: string) => {
  const sanitizedValue = value.trim();
  const regex = /^[a-zA-Z ]{1,256}$/;
  if (!regex.test(sanitizedValue)) {
    return "* Enter the value in the appropriate format.";
  }
  return "";
};

export const validateAddress = (value: string) => {
  const sanitizedValue = value.trim();
  const regex = /^[a-zA-Z0-9 .'-]{1,256}$/;
  if (!regex.test(sanitizedValue)) {
    return "*Please enter a valid address format";
  }
  return "";
};

export const validateStateOrCity = (value: string) => {
  const sanitizedValue = value.trim();
  const regex = /^[a-zA-Z .'-]{1,64}$/;
  if (!regex.test(sanitizedValue)) {
    return "*Please enter a valid format";
  }
  return "";
};
